import React, { useEffect, useState } from "react";
import { Grid, Cell, SelectionControl } from "react-md";

interface MCheckboxGroupProps {
  // Note that values are set in useEffect. If you're going to pass a func to get the options,
  // be sure to memoize it so it doesn't get called every render and reset the selections
  fields: MCheckboxGroupOption[]; 
  cellSize?: number;
  containerClassName?: string;
  controlMethods?: (methods: MCheckboxGroupControlMethods) => void;
  onChange?: (value: string, checked: boolean) => void;
}

export interface MCheckboxGroupOption {
  value: string; // this is meant to be a code to identify the field, it isnt the value of if its checked or not
  label: string;
  defaultChecked?: boolean;
  disabled?: boolean;
  checked?: boolean; // this doesnt seem to be used?
}

export interface MCheckboxGroupControlMethods {
  getValues: () => MCheckboxValue[];  // Get all checkbox values
  getChecked: () => string[]; // Get selected values
  getUnChecked: () => string[]; // Get unselected values
  checkAll: () => void; // Select all
  unCheckAll: () => void; // Unselect all
}

export interface MCheckboxValue {
  value: string;
  checked: boolean;
}

const MCheckboxGroup = (props: MCheckboxGroupProps) => {
  const [options, setOptions] = useState<boolean[]>(props.fields.map(f => !!f.defaultChecked));

  useEffect(() => {
    if (props.controlMethods) {
      props.controlMethods({
        getValues: () => options.map((value, i) => ({ value: props.fields[i].value, checked: value})),
        getChecked: () => options.map((value, i) => value ? props.fields[i].value : null).filter(o => o !== null),
        getUnChecked: () => options.map((value, i) => value ? null : props.fields[i].value).filter(o => o !== null),
        checkAll: () => setOptions(props.fields.map(() => true)),
        unCheckAll: () => setOptions(props.fields.map(() => false)),
      });
    }
  });

  useEffect(() => {
    setOptions(props.fields.map(f => !!f.defaultChecked));
  }, [props.fields]);

  const onChange = (index: number) => {
    const newOptions = [...options];
    newOptions[index] = !newOptions[index];
    setOptions(newOptions);
    props.onChange?.(props.fields[index].value, newOptions[index]);
  };

  return (
    <Grid>
        {props.fields.map(({ label, defaultChecked, disabled }, index) =>
          <Cell key={`${label}-${index}`} size={props.cellSize}>
            <SelectionControl
              {...{ label, defaultChecked, disabled }}
              key={`checkbox-${index}`}
              checked={options[index]}
              onChange={() => onChange(index)}
              type="checkbox"
              name={label}
              id={label}
              className={props.containerClassName}
            />
          </Cell>
        )}
      </Grid>
  );
};

export default MCheckboxGroup;